export const SET_THEME = '@theme/SET_THEME';
export const TOGGLE_SYSTEM_SYNC = '@theme/TOGGLE_SYSTEM_SYNC';
